import { SITE } from "~/constants"

/** pathname + search. Aceita url absoluta ou relativa (resolvida contra a origem da loja). */
export function relative(url: string) {
    const link = new URL(url, SITE.URL)
    return `${link.pathname}${link.search}`
}
